module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMCAAAAAChTgljAAAAAXNSR0IArs4c6QAAAHpJREFUCB0Fwb0KggAYAMDvSfyFBiehaHRrbA4CHQQTdAsUQ6x79O4iGQDAkMRaPAHwLNawV3cA92oXfK/ND/ya65eAW33gqG8Q4FJ+fMozCHhUXfbKuuoBgfZ0mPLJcWoR9OUO2MueMOYbgC0fxZwuAFiyOdI3AHinf/KrV67Y8iXYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/email.png
// module id = nqWK
// module chunks = 0